import OtherSysContainer from './OtherSysContainer'

export default OtherSysContainer
